module.exports = __webpack_public_path__ + "img/4 Solution.561ac902.png";